var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame699({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7578 22.45L22.3703 19.8375L15.6328 13.375L14.2578 14.75L16.5953 17.0875L15.4953 18.1875L17.1453 19.8375L18.2453 18.7375L19.4828 19.975L18.3828 21.075L19.7578 22.45Z",
    fill: "#3498DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85714 16.3984C13.9592 16.3984 17.2846 13.0126 17.2846 8.83594C17.2846 4.65928 13.9592 1.27344 9.85714 1.27344C5.75507 1.27344 2.42969 4.65928 2.42969 8.83594C2.42969 13.0126 5.75507 16.3984 9.85714 16.3984ZM7.74968 3.20706C5.49745 3.97589 3.89179 6.18955 3.83099 8.52939C3.81922 8.97984 3.97482 9.22304 4.28275 9.23285C4.57629 9.24135 4.726 9.03737 4.75215 8.58758C4.9071 5.88424 6.94816 3.86345 9.63646 3.74904C10.0523 3.73138 10.2458 3.56533 10.2314 3.26394C10.217 2.96255 10.0039 2.78146 9.59396 2.83834C9.55707 2.84351 9.52012 2.84866 9.48313 2.85381C8.89812 2.93535 8.30308 3.01829 7.74968 3.20706Z",
    fill: "#3498DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame699);
export default __webpack_public_path__ + "static/media/Frame 699.455f94c37911d032df04d26e89655347.svg";
export { ForwardRef as ReactComponent };